import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import axios from 'axios';

interface IProps {
  hasLabel?: any;
}

type FormValues = {
  email: string;
};

const validationSchema = Yup.object().shape({
  email: Yup.string().email('Email is invalid').required('Email ID is required'),
});

const EmailVerifyForm = ({ hasLabel }: IProps) => {
  const [submitted, setSubmitted] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm<FormValues>({
    resolver: yupResolver(validationSchema),
    mode: 'onChange',
  });

  const onSubmit = handleSubmit(
    async (payload) => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_GATEWAY_HOST}/api/user-management/v1/users/email/verify/resend`,
          { email: payload.email }
        );

        toast.dark(response.data.responseMsg);
        if (response.data.responseCode === 'SUCCESS') {
          setSubmitted(true);
        }
      } catch (error: any) {
        const message = error?.response?.data?.responseMsg;
        const responseCode = error?.response?.data?.responseCode;
        // Show "Email already verified" as success toast instead of error
        if (responseCode === 'OPERATION_NOT_ALLOWED') {
          toast.success(message ?? 'Something went wrong. Please try again.');
        } else {
          toast.error(message ?? 'Something went wrong. Please try again.');
        }
        console.error('Resend verification error:', error);
      }
    },
    (error: any) => {
      console.error('Handle submit error: ', error);
    }
  );

  if (submitted) {
    return (
      <div className='text-center fs--1'>
        <p>
          A new verification link has been sent. Please check your inbox.
        </p>
        <a href={`${process.env.REACT_APP_CLIENT_APP_HOST}/app`} className='link'>
          Back to login
        </a>
      </div>
    );
  }

  return (
    <Form onSubmit={onSubmit}>
      <Form.Group className='mb-3 mt-2'>
        {hasLabel && (
          <Form.Label htmlFor='floatingInput'>Email address</Form.Label>
        )}
        <Form.Control
          placeholder={!hasLabel ? 'Email address' : ''}
          type='email'
          {...register('email')}
          className={`fs--1 inputBorder form-control ${errors.email ? 'is-invalid' : ''}`}
          onChange={({ target }) => {
            setValue('email', target.value.trim().toLowerCase());
          }}
        />
        <div className='invalid-feedback'>
          {errors.email?.message?.toString()}
        </div>
      </Form.Group>
      <div className='row'>
        <div className='d-flex justify-content-center align-items-center col-12'>
          <Form.Group className='text-center'>
            <Button type='submit' className='mt-2 w-100'>
              Submit
            </Button>
          </Form.Group>
        </div>
      </div>
    </Form>
  );
};

export default EmailVerifyForm;

